/**
 * Generates a box shadow for a specific elevation
 */
const generateShadow = (elevation?: number): string => {
  if (!elevation) return 'none';

  return `0px ${elevation + 1}px ${elevation + 3}px 0px rgba(0,0,0,0.05)${
    elevation > 3 ? `,0px 0px ${elevation - 3}px 0px rgba(0,0,0,0.05)` : ''
  }`;
};

export default generateShadow;
